module.exports = __webpack_public_path__ + "images/thumbs-up664aa3895bfdfbf9f9e6aa863f337574.svg";